<template>
  <div>
    <div style="padding-top: 2%; text-align: center; margin-bottom: 5%">
      <h2 style="font-family: customFont">Welcome to Blood Donor Network</h2>
    </div>
    <div style="text-align: center">
      <img style="width: 300px" src="@/assets/img/loading2.gif" alt="">
    </div>
    <div style="padding-top: 5%; text-align: center">
      <h3 style="font-family: customFont">Verifying Login . . .</h3>
    </div>
    
  </div>
</template>
<script>
  export default {
    name: 'ProgressBarQuery',
    beforeMount() {
      firebase.auth().onAuthStateChanged((user) => {
        if (user) {
          let paramsBody = {
            'grant_type': 'password',
            'client_id': '2',
            'client_secret': 'cEfaCbnoQzDFJqfAAC2kPpEkZQJpOKJ2Hd0ZtQ9v',
            'username': user.phoneNumber,
            'password': 'bdnbd'
          };
          this.$store.dispatch('LogIn', paramsBody)
            .then((response) => {
              if (response.status == 200) {
                localStorage.setItem('auth-response', JSON.stringify(response.data));
                this.$store.dispatch('LoggedUser', paramsBody)
                  .then((res) => {
                    if (res.status == 200) {

                      localStorage.setItem('user-response', JSON.stringify(res.data));
                      this.$router.push({name : 'DashboardLayout'})
                    }
                  })
                  .catch(error => {
                  });
              }
            }).catch((error) => {
              if (error.response.status == 401){
                this.$store.dispatch('RegisterNewUser',{
                  "user_role_id": 2,
                  "phone_number": user.phoneNumber
                }).then(response => {
                  if (response.status == 201){

                    let paramsBody = {
                      'grant_type': 'password',
                      'client_id': '2',
                      'client_secret': 'cEfaCbnoQzDFJqfAAC2kPpEkZQJpOKJ2Hd0ZtQ9v',
                      'username': user.phoneNumber,
                      'password': 'bdnbd'
                    };
                    this.$store.dispatch('LogIn', paramsBody)
                      .then((response) => {
                        if (response.status == 200) {
                          localStorage.setItem('auth-response', JSON.stringify(response.data));
                          this.$store.dispatch('LoggedUser', paramsBody)
                            .then((response) => {
                              if (response.status == 200) {
                                localStorage.setItem('user-response', JSON.stringify(response.data));
                                this.$router.push({name : 'DashboardLayout'})
                              }
                            })
                            .catch(error => {
                            });
                        }
                      })
                      .catch(error => {
                      });

                  }
                }).catch(error => {

                })
              }
          })

        } else {
          this.$router.push({name: 'Login'})
          // User is signed out.
        }
      }, function (error) {

      });
    }
  }
</script>
<style lang="scss" scoped>
  .md-progress-bar {
    margin: 24px;
  }
  @font-face {
    font-family: customFont;
    src: url('../../assets/font/LBRITED.TTF');
  }
</style>
